import { useTranslation } from 'react-i18next'

import { BotaoMidia } from './botao-midia'
import { SecaoDetalhesEmpreendimento } from './secao'

type TSecaoMidiasProps = {
  onFotosClick?: () => void
  onPlantasClick?: () => void
  onBookClick?: () => void
}

export const SecaoMidias = ({ onBookClick, onFotosClick, onPlantasClick }: TSecaoMidiasProps) => {
  const { t } = useTranslation('empreendimentos')

  return (
    <SecaoDetalhesEmpreendimento titulo={t('pages.detalhes.secoes.midia.titulo')}>
      <div className="grid grid-cols-3 gap-6">
        <BotaoMidia titulo={t('pages.detalhes.secoes.midia.fotos')} icon="camera" onClick={onFotosClick} />
        <BotaoMidia titulo={t('pages.detalhes.secoes.midia.plantas')} icon="floor-plan" onClick={onPlantasClick} />
        <BotaoMidia titulo={t('pages.detalhes.secoes.midia.book')} icon="book-open" onClick={onBookClick} />
      </div>
    </SecaoDetalhesEmpreendimento>
  )
}
